// src/fontawesome.js
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faAngleLeft,
    faAngleRight,
    faAnglesRight,
    faAnglesLeft,
    faTrashCan,
    faPen,
    faForwardStep,
    faBackwardStep,
    faCheck,
    faXmark,
    faCalendar,
    faUtensils,
    faHouse,
    faChartSimple,
    faChampagneGlasses,
    faAddressBook,
    faPlus,
    faRotateRight,
    faRightFromBracket,
    faRightToBracket,
    faBars,
    faSortUp,
    faSortDown,
    faArrowDownAZ,
    faArrowDownZA,
    faFilter,
    faMagnifyingGlass,
    faArrowUpShortWide,
    faArrowDownWideShort
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faAngleLeft,
    faAngleRight,
    faAnglesRight,
    faAnglesLeft,
    faTrashCan,
    faPen,
    faForwardStep,
    faBackwardStep,
    faCheck,
    faXmark,
    faCalendar,
    faUtensils,
    faHouse,
    faChartSimple,
    faChampagneGlasses,
    faAddressBook,
    faPlus,
    faRotateRight,
    faRightFromBracket,
    faRightToBracket,
    faBars,
    faSortUp,
    faSortDown,
    faArrowDownAZ,
    faArrowDownZA,
    faFilter,
    faMagnifyingGlass,
    faArrowUpShortWide,
    faArrowDownWideShort
);
